import {Box} from "@mui/system";
import {QuillEditor} from "../../../../../../../common";

export default function DirectMessageEditor({isEmail, handleTextChange}) {

    return(
        <Box>
            <QuillEditor
                handleTextChange={handleTextChange}
                isEmail={isEmail}
            />
        </Box>
    )
}